import { render, staticRenderFns } from "./candidateAppointmentHistory.vue?vue&type=template&id=1863dc5b&"
import script from "./candidateAppointmentHistory.vue?vue&type=script&lang=js&"
export * from "./candidateAppointmentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports